import { Cart } from 'es6/collections/cart'
import recommendationsEvents from 'init/recommendations-events'
import { settlement } from 'init/settlement'
import { user } from 'init/user'
/**
 * Инициализация корзины
 */
export const cart = new Cart(null, { settlement: settlement, user: user, recommendationsEvents: recommendationsEvents })
